class InsiderTracking {
  constructor() {
    this.knownBrands = {
      'Koala': 'Koala',
      'Protein+': 'Protein+',
      'Supercoffee': 'SuperCoffee',
      'SuperCoffee': 'SuperCoffee',
      'Morning Shot': 'Morning Shot',
      'Whey': 'Labs',
      'Cratina': 'Labs',
      'Pack': 'Pack',
    };
    this.knownCategories = {
      '380g': 'Economic',
      '456g': 'Economic',
      '220g': 'Classic',
      '264g': 'Classic',
      'Morning Shot': 'Classic',
      'Whey': 'Labs',
      'Cratina': 'Labs',
      'Pack': 'Pack',
    }
  }

  async trackEvent(eventName, eventParams) {
    window.Insider.track('events', [{
      "event_name": eventName,
      "timestamp": String(Math.floor(Date.now() / 1000)),
      "event_params": eventParams
    }]);
  }

  trackPageView(pageName) {
    const path = window.location.pathname;
    if (pageName) {
      this.trackEvent('page_view', {
        'page_name': pageName,
        'url': window.location.href,
      });
    } else {
      this.trackEvent('page_view', {
        'page_name': path === '/' ? 'Home Page' : path.replace(/\//g, '-').substring(1),
        'url': window.location.href,
      });
    }
  }

  findProductBrand(productTitle) {
    const titleLower = productTitle.toLowerCase();

    for (const brand in this.knownBrands) {
      if (titleLower.includes(brand.toLowerCase())) {
        return this.knownBrands[brand];
      }
    }
    return 'unknown';
  }

  findProductFlavor(productTitle) {
    if (productTitle.toLowerCase().includes('pack')) return 'Pack';
    const brandsRegex = new RegExp(Object.keys(this.knownBrands).join('|') + '|380g|456g|220g', 'gi');
    const flavorMatch = productTitle.replace(brandsRegex, '').replace(/\s+/g, ' ').trim();
    return flavorMatch || 'unknown';
  }

  findProductCategory(productTitle) {
    const titleLower = productTitle.toLowerCase();

    for (const category in this.knownCategories) {
      if (titleLower.includes(category.toLowerCase())) {
        return this.knownCategories[category];
      }
    }
    return 'unknown';
  }
  handleStorefrontFilter(eventAction, filterName, sectionName) {
    if (eventAction === 'add') {
      this.trackEvent('ecom_storefront_filter_applied', {
        filter_value: filterName,
        section_name: sectionName
      });
    } else {
      this.trackEvent('ecom_storefront_filter_removed', {
        filter_value: filterName,
        section_name: sectionName
      });
    }
  }
  calculateDistanceFromTop(element) {
    const rect = element.getBoundingClientRect();
    return Number((rect.top + window.scrollY).toFixed(0));
  }

  handleAddToCartDestructured(variantId, price, productName, source) {
    loadAndUpdateCart(variantId);
    this.trackEvent("ecom_add_to_cart", {
      "pid": variantId,
      "p_price": price / 100,
      "p_event_source": source,
      "c_product_name": productName
    });
  }

  handleCartContinueShopping() {
    closeCartDrawer()
    this.trackEvent('ecom_cart_continue_shopping_click', {
      'c_cart_total_value': cartObject.total_price / 100,
      'c_cart_item_count': cartObject.item_count,
      'c_cart_subtotal_value': cartObject.original_total_price / 100,
      'c_cart_applied_discount': cartObject.total_discount / 100,
    });
  }


  async handleCartBeginCheckout(cuponCode) {
    if (!cartObject) {
      window.location.href = '/checkout';
      return;
    }
    await this.trackEvent('cart_begin_checkout', {
      'c_cart_total_value': cartObject.total_price / 100,
      'c_cart_item_count': cartObject.item_count,
      'c_cart_subtotal_value': cartObject.original_total_price / 100,
      'c_cart_applied_discount': cartObject.total_discount / 100,
      'c_has_free_gift': cartObject.items?.some(item => item.handle.includes('brinde')),
    }).then(() => {
      if (cuponCode) {
        handleCheckoutWithDiscount(cuponCode)
      } else {
        window.location.href = '/checkout';
      }
    });
  }
  async handleClickOnBannerRedirect(link, id, blockSettings, openFastShop = false) {
    const banner = document.getElementById(`banner-${id}`);
    await this.trackEvent('ecom_storefront_banner_click', {
      "c_position": this.calculateDistanceFromTop(banner),
      "c_file_name": blockSettings.image_desktop ? blockSettings.image_desktop : (blockSettings.banner_image ? blockSettings.banner_image : 'no_image'),
      "c_link": link ? link : 'no_link',
    }).then(() => {
      if (link && !openFastShop) {
        window.location.href = link;
      }
    });
  }

  handleClearCart() {
    clearCart()
    this.trackEvent('ecom_cart_clear', {
      'c_cart_total_value': cartObject.total_price / 100,
      'c_cart_item_count': cartObject.item_count,
      'c_cart_subtotal_value': cartObject.original_total_price / 100,
      'c_cart_applied_discount': cartObject.total_discount / 100,
      'c_has_free_gift': cartObject.items.some(item => item.handle.includes('brinde')),
    });
  }

  handleStorefrontBannerClick(id, blockSettings) {
    const banner = document.getElementById(`banner-${id}`);
    this.trackEvent('ecom_storefront_banner_click', {
      "c_position": this.calculateDistanceFromTop(banner),
      "c_file_name": blockSettings.image_desktop ? blockSettings.image_desktop : 'no_image',
      "c_link": blockSettings.link ? blockSettings.link : 'no_link',
    });
  }

  observeStorefrontProductCard(productCardSelector, productData, sectionId, productFlavor) {
    const productCard = document.getElementById(productCardSelector);

    if (!productCard) return;

    const productCardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.trackEvent('ecom_product_impression', {
            "pid": productData.variants[0].id,
            "c_product_name": productData.variants[0].name,
            "c_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
            "c_brand": this.findProductBrand(productData.title),
            "c_position": this.calculateDistanceFromTop(productCard),
            "c_category": this.findProductCategory(productData.title),
            "c_sabor": productFlavor ? productFlavor : this.findProductFlavor(productData.title),
            "c_list_name": sectionId,
          });
          productCardObserver.unobserve(productCard);
        }
      });
    });

    productCardObserver.observe(productCard);
  }
  async trackProductStorefrontClick(element, productData) {
    const { flavor, listName } = element.dataset;
    await this.trackEvent('ecom_product_storefront_product_click', {
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "c_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
      "c_brand": this.findProductBrand(productData.title),
      "c_position": this.calculateDistanceFromTop(element),
      "c_category": this.findProductCategory(productData.title),
      "c_sabor": flavor ? flavor : this.findProductFlavor(productData.title),
      "c_list_name": listName,
    }).then(() => {
      if (this.findProductCategory(productData.title) !== 'Pack') {
        redirectTo(`/products/${productData.handle}`);
      }
    }
    )
  }

  async trackProductStorefrontAddToCartClick(element, productData) {
    const { flavor, listName } = element.dataset;
    this.trackEvent('ecom_product_storefront_product_cart_add', {
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "c_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
      "c_brand": this.findProductBrand(productData.title),
      "c_position": this.calculateDistanceFromTop(element),
      "c_category": this.findProductCategory(productData.title),
      "c_sabor": flavor ? flavor : this.findProductFlavor(productData.title),
      "c_list_name": listName,
    })
  }
  handleAddToCart(productData, source) {
    this.trackEvent("ecom_add_to_cart", {
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "p_price": (productData.variants[0].compare_at_price ? productData.variants[0].compare_at_price : productData.variants[0].price) / 100,
      "c_event_source": source,
    });
  }
  handleSupportComponentClick(componentName, productData, clickedElement = null) {
    this.trackEvent('ecom_product_support_component_click', {
      "c_component_name": componentName,
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "c_brand": this.findProductBrand(productData.title),
      "c_category": this.findProductCategory(productData.title),
      "c_sabor": this.findProductFlavor(productData.title),
    });
  }
  handleCrossSellSelection(
    productData,
    selectedProductData,
    selector,
    isInput = false
  ) {
    const element = document.querySelector(selector);
    const selectedProduct = JSON.parse(selectedProductData);
    this.trackEvent('ecom_cross_sell_click', {
      "c_main_product_id": String(productData.variants[0].id),
      "c_product_name": selectedProduct.product_title,
      "pid": String(selectedProduct.selected_product_id),
      "c_price": Number(selectedProduct.selected_product_price),
      "c_action": isInput ? (element.checked ? 'select' : 'deselect') : (!element.checked ? 'select' : 'deselect')
    })
  }
  async handleCrossSellpurchase(productItems, mainProductData) {
    const fullPrice = document.getElementById('crossSellFullPrice') ? document.getElementById('crossSellFullPrice').value : null;
    this.trackEvent('ecom_bundle_add_to_cart', {
      "pid": String(mainProductData.variants[0].id),
      "c_bundle_products": productItems.map(item => String(item.id ? item.id : item.currentProduct)),
      "c_bundle_size": productItems.length,
      "c_purchase_type": 'one_time',
      "c_price": fullPrice ? Number(fullPrice) : null,
      "c_event_source": "pdp_cross_sell"
    });
  }
  async handleProductFixedBarAddToCart(productData, id) {
    if (id) setButtonLoadSpinner(id, 5000);
    addToCart(productData.variants[0].id, 1);
    this.handleAddToCart(productData, "product_fixed_bar");
  }
  async handlePdpSubscriptionClick(productData, id, callback = () => { }, productItems = [], source = "pdp_subscription") {
    if (id) setButtonLoadSpinner(id, 5000)
    let fullPrice;
    if (productItems.length > 0) {
      fullPrice = document.getElementById('crossSellFullPrice') ? document.getElementById('crossSellFullPrice').value : null;
    }
    this.trackEvent('ecom_subscription_start_prime', {
      "pid": productData.variants[0].id,
      "c_product_name": productData.variants[0].name,
      "c_brand": this.findProductBrand(productData.title),
      "c_category": this.findProductCategory(productData.title),
      "c_sabor": this.findProductFlavor(productData.title),
      "c_bundle_products": productItems.map(item => String(item.id ? item.id : item.currentProduct)),
      "c_bundle_size": productItems.length,
      "c_price": productItems.length > 0 ? fullPrice ? Number((Number(fullPrice) * 0.8).toFixed(2)) : Number(fullPrice) : (productData.variants[0].price / 100) * 0.8,
      "c_event_source": source,
      'c_purchase_type': 'prime'
    }).then(() => {
      if (callback) callback();
    });
  }
  handlePdpImagesInteraction(productData, imageIndex, interactionType, activeImg = null) {
    if (typeof activeImg === 'object') {
      this.trackEvent('ecom_pdp_view_product_image', {
        "pid": productData.variants[0].id,
        "c_product_name": productData.variants[0].name,
        "c_media_url": activeImg ? activeImg.src ? activeImg.src : activeImg.sources[1].url : 'no_image',
        "c_file_name": activeImg ? activeImg.src ? activeImg.src.split('/').pop() : activeImg.sources[1].url.split('/').pop() : 'no_image',
        "c_banner_position": activeImg.position,
        "c_media_type": activeImg.media_type,
        "c_interaction_type": interactionType,
      });
    } else {
      this.trackEvent('ecom_pdp_view_product_image', {
        "pid": productData.variants[0].id,
        "c_product_name": productData.variants[0].name,
        "c_media_url": activeImg ? activeImg : 'no_image',
        "c_file_name": activeImg ? activeImg.split('/').pop() : 'no_image',
        "c_banner_position": imageIndex + 1,
        "c_media_type": imageIndex === 0 ? 'img' : 'video',
        "c_interaction_type": interactionType,
      });
    }
  }
  handleHomeBannerClick(link, bannerImage, bannerImageMobile, bannerPosition) {
    const responsiveImage = window.innerWidth <= 768 ? bannerImageMobile : bannerImage;
    this.trackEvent('ecom_home_banner_click', {
      "c_file_name": responsiveImage.split('/').pop(),
      "c_banner_position": bannerPosition,
      "c_link": link ? link : 'no_link',
      "list_name": 'home_page_banners'
    }).then(() => {
      if (link) window.location.href = link;
    });
  }
  handleProductGridClick(brand, url) {
    this.trackEvent('ecom_product_grid_product_click', {
      "c_brand": brand,
      "url": url
    }).then(() => {
      if (url) window.location.href = url;
    })
  }
  handleHomepageAddToCart(productData, source) {
    this.trackEvent("ecom_add_to_cart", {
      "pid": productData.variantId,
      "c_product_name": productData.name,
      "p_price": productData.price / 100,
      "c_event_source": source,
    });
  }
  handleHomePagePrimeBannerClick(link) {
    this.trackEvent('ecom_prime_click_home')
    if (link) window.location.href = link;
  }
  async headerItemClick(itemTitle, url, location) {
    if (url?.includes('app.caffeinearmy.com.br')) {
      this.trackEvent('prime_click_menu', {
        'menu_item': itemTitle,
        "destination_url": url,
        "menu_location": location ? location : 'unknown',
      }).then(() => {
        if (url) window.location.href = url;
      });
    } else {
      await this.trackEvent('header_item_click', {
        'menu_item': itemTitle,
        "menu_location": location ? location : 'unknown',
        "destination_url": url
      }).then(() => {
        if (url) window.location.href = url;
      });
    }
  }
  async handleMegaMenuShowAllProductsClick(allProductsLink, brand) {
    await this.trackEvent('ecom_show_all_products', {
      "brand": brand ? brand : 'unknown',
      "c_link": allProductsLink ? allProductsLink : 'no_link',
    }).then(() => {
      if (allProductsLink) window.location.href = allProductsLink;
    });
  }
  async handleMegaMenuBannerClick(link, brand, bannerImage) {
    await this.trackEvent('ecom_header_banner_click', {
      "brand": brand,
      "c_link": link ? link : 'no_link',
      "c_file_name": bannerImage ? bannerImage.split('/').pop() : 'no_image',
    }).then(() => {
      if (link) window.location.href = link;
    });
  }
  async handleMegaMenuItemClick(productName, brand, productId, link) {
    await this.trackEvent('ecom_header_select_item_menu', {
      "brand": brand,
      "c_product_name": productName,
      "pid": productId,
      "url": link ? link : 'no_link',
    }).then(() => {
      if (link) window.location.href = link;
    });
  }
  async handleMegaMenuItemVariantClick(productName, brand, productId, variant, link) {
    await this.trackEvent('ecom_header_product_variant_click', {
      "brand": brand,
      "variant": variant.replace("<p>", "").replace("</p>", ""),
      "c_product_name": productName,
      "pid": productId,
      "url": link ? link : 'no_link',
    }).then(() => {
      if (link) window.location.href = link;
    });
  }
}
const insiderTracking = new InsiderTracking();